import { Button, Form } from "react-bootstrap";
import { React, useState, useEffect, useRef } from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import { getAdminById, updateAdminById } from "../../api/axios";
import CmsCircularProgress from "../Common/CircularProgress";
import { showToast } from "../../Utills/toast";
import FormGroup from "../Common/FormGroup";
import { Formik } from "formik";
import * as Yup from "yup";

// Validation schema
const validationSchema = Yup.object({
  admin_name: Yup.string().required("Name is required"),
  email: Yup.string().required("Email is required"),
  profile_pic: Yup.mixed().required("Profile picture is required"),
});

const UpdateAdmin = () => {
  const { id, partnerId } = useParams();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [initialData, setInitialData] = useState({
    admin_name: "",
    email: "",
    profile_pic: "",
  });
  const inputRef = useRef(null);
  const formikRef = useRef(null);

  const fetchAdminData = async (adminId) => {
    setIsLoading(true);
    try {
      const res = await getAdminById(adminId);
      const adminData = res.data.data[0];
      
      const formData = {
        admin_name: adminData.admin_name || "",
        email: adminData.email || "",
        profile_pic: adminData.profile_pic || "",
      };
      
      setInitialData(formData);
      
      // Reset Formik with new data if component is mounted
      if (formikRef.current) {
        formikRef.current.resetForm({
          values: formData
        });
      }
    } catch (err) {
      showToast({
        type: 'error',
        message: 'Failed to fetch admin details. Please try again.',
      });
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchAdminData(id);
  }, [id]);

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      const formData = new FormData();
      formData.append("admin_name", values.admin_name);
      formData.append("email", values.email);

      if (values.profile_pic instanceof File) {
        formData.append("profile_pic", values.profile_pic);
      }

      const res = await updateAdminById(id, formData);
      console.log(res);
      if (res.status === 200) {
        showToast({
          type: 'success',
          message: 'Admin details have been updated successfully!',
        });
        // Fetch the updated data
        await fetchAdminData(id);
      } else {
        showToast({
          type: 'error',
          message: 'Failed to update admin details. Please try again.',
        });
      }
    } catch (err) {
      console.log(err);
      showToast({
        type: 'error',
        message: 'Failed to update admin details. Please try again.',
      });
    } finally {
      setSubmitting(false);
    }
  };

  const handleClick = () => {
    navigate(`/${partnerId}/admin/view`);
  };


  return (
    <>
    {isLoading ? <CmsCircularProgress/> :<ContentWrapper>
      <Formik
        innerRef={formikRef}
        initialValues={initialData}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
        enableReinitialize={true}
      >
        {({ handleSubmit, getFieldProps, setFieldValue, values, errors, touched, isSubmitting }) => (
          <Form
            style={{
              margin: "auto",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
            }}
            onSubmit={handleSubmit}
            noValidate
          >
            <Title>EDIT detais of admin {values.admin_name}</Title>
            <SliderDiv>
              <FormGroup
                label='Click here to change the profile picture'
                requiredField
                error={touched.profile_pic && errors.profile_pic}
              >
                <div>
                  <Form.Control
                    type="file"
                    accept="image/*"
                    onChange={(e) => {
                      setFieldValue("profile_pic", e.target.files[0]);
                    }}
                    style={{ display: "none" }}
                    ref={inputRef}
                    isInvalid={touched.profile_pic && errors.profile_pic}
                  />
                  {values.profile_pic instanceof File ? (
                    <BootstrapImage
                      src={URL.createObjectURL(values.profile_pic)}
                      alt="profile_pic"
                      onClick={() => {
                        inputRef.current.click();
                      }}
                    />
                  ) : (
                    <BootstrapImage
                      src={values.profile_pic}
                      alt="profile_pic"
                      onClick={() => {
                        inputRef.current.click();
                      }}
                    />
                  )}
                </div>
              </FormGroup>

              <FormGroup 
                label='Name'
                requiredField
                error={touched.admin_name && errors.admin_name}
              >
                <Form.Control
                  type="text"
                  placeholder="Enter admin name"
                  {...getFieldProps("admin_name")}
                  isInvalid={touched.admin_name && errors.admin_name}
                />
              </FormGroup>
              
              <FormGroup 
                label='Email'
                requiredField
                error={touched.email && errors.email}
              >
                <Form.Control
                  type="email"
                  placeholder="Enter email"
                  {...getFieldProps("email")}
                  isInvalid={touched.email && errors.email}
                />
              </FormGroup>

              <ButtonWrapper>
                <Button
                  variant="secondary"
                  onClick={handleClick}
                  style={{
                    cursor: "pointer",
                    width: "auto",
                  }}
                >
                 Go  Back
                </Button>
                <Button
                  variant="primary"
                  type="submit"
                  disabled={isSubmitting}
                  style={{
                    cursor: "pointer",
                    width: "auto",
                  }}
                >
                  {isSubmitting ? "Saving..." : "Save Changes"}
                </Button>
              </ButtonWrapper>
            </SliderDiv>
          </Form>
        )}
      </Formik>
    </ContentWrapper>}
    </>
  );
};

export default UpdateAdmin;

const ContentWrapper = styled.div`
  @media (min-width:576px) {
    padding: 1rem;
    }
    @media (min-width:768px) {
   padding: 1.5rem;
  }
   padding: .5rem;
  justify-content: center;
`;

const Title = styled.h3`
  text-align: center;
`;

const ButtonWrapper = styled.div`
  margin: 0 auto;
  padding-top: 30px;
  display: flex;
  gap: 5rem;
  justify-content: center;
    @media (max-width: 890px) {
   justify-content: end;
    gap: 2rem;
  }
   @media (max-width: 425px) {
     gap: 1rem;
  }
`;
const SliderDiv = styled.div`
  width: 100%;
  max-width: 800px;
  margin: 0 auto;
`;
const BootstrapImage = styled('img')(({ theme }) => ({
  maxWidth: "15vw",
  cursor: "pointer",
  "@media (max-width: 576px)": {
    maxWidth: "60vw",
  },
}));